import { render } from "./BugDetail.vue?vue&type=template&id=e8330d46&scoped=true"
import script from "./BugDetail.vue?vue&type=script&lang=js"
export * from "./BugDetail.vue?vue&type=script&lang=js"

import "./BugDetail.vue?vue&type=style&index=0&id=e8330d46&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8330d46"]])

export default __exports__